"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var Announcement = /** @class */ (function (_super) {
    __extends(Announcement, _super);
    function Announcement(props) {
        var _this = _super.call(this, props) || this;
        _this.buildItem = function (settings, blocks, item, i) { return (React.createElement("div", { key: i, className: "px-1-4 flex flex-col md:flex-row absolute pin items-center flex py-1 px-3 md:px-1 announce-rest\n      " + (_this.state.visible == i ? "announce-trans-in" : "announce-trans-out") },
            item.linkurl && item.linktext ? React.createElement(Snippets.Svg, { name: "location", width: 13, className: "block fill-current mr-1" }) : null,
            React.createElement("p", { className: "font-body font-medium text-sm" }, item.title),
            item.linkurl && item.linktext ? (React.createElement("a", { href: item.linkurl, title: item.title, className: "flex items-center justify-between underline text-sm transition-fast hover:opacity-75 ml-1" }, item.linktext)) : null)); };
        _this.state = {
            visible: 0
        };
        return _this;
    }
    Announcement.prototype.componentDidMount = function () {
        var _this = this;
        var count = this.props.section.blocks.length;
        if (count > 1) {
            var time = 4000;
            this.timer = setInterval(function () {
                _this.state.visible < count - 1 ? _this.setState({ visible: _this.state.visible + 1 }) : _this.setState({ visible: 0 });
            }, time);
        }
    };
    Announcement.prototype.componentWillUnmount = function () {
        clearInterval(this.timer);
    };
    Announcement.prototype.render = function () {
        var _this = this;
        // const { title, linktext, linkurl, background, foreground } = this.props.section.settings;
        var _a = this.props.section, settings = _a.settings, blocks = _a.blocks;
        return (React.createElement("div", { className: (this.state.closed ? "max-h-0 invisible opacity-0" : "max-h-1/2-h visible translate-y:0 opacity-100 transition-delay-5") + " transition-fast bg-" + settings.background + " text-" + settings.foreground + " w-full relative lg:block hidden" },
            React.createElement(Snippets.Container, { className: "flex flex-wrap mlg:px-11 md:pl-2-4 md:pr-6 px-1-6", tag: "section" },
                React.createElement("div", { id: "notification", className: "flex items-start md:items-center justify-between text-center leading-none -mx-1-4 flex-grow" },
                    React.createElement("div", { className: "flex-grow px-1-4 flex flex-col md:flex-row items-center justify-center" },
                        React.createElement("div", { className: "flex-grow relative h-4" }, blocks ? blocks.map(function (block, i) { return _this.buildItem(settings, blocks, block.settings, i); }) : [])),
                    React.createElement("div", { className: "flex" },
                        React.createElement(Snippets.UtilityLinks, __assign({ style: "small", linklist: this.props.data.linklist[next_components_1.ShopifyNext.Utils.getMenu(settings.utilitynav)] }, this.props)))))));
    };
    Announcement.sectionId = "announcement";
    Announcement.contextType = next_components_1.ShopifyNext.Context;
    return Announcement;
}(React.PureComponent));
exports.Announcement = Announcement;
